import React from "react";
import CompanyOverview from './Pages/overview'
import {CryptDecrypt} from "../../../@WUM/core/Elements/crypt/Crypt";
import CompanyIndex from "./Pages";
import CompanyOverviewNew from "./Pages/new";

export const CompanyConfig = (value:any) => {
    if(localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined && JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string).isMandant === false) {
        return []
    } else {
        return [
            {
                path: '/company/overview/:page',
                elements: <CompanyOverview value={value}/>,
                roles: ['superadmin', 'admin',
                    'ticketsystem',
                    'worktime',
                    'teamtakt']
            },
            // {
            //     path: '/company/index-overview/:page',
            //     elements: <CompanyIndex value={value}/>,
            //     roles: ['superadmin', 'admin',
            //         'ticketsystem',
            //         'worktime',
            //         'teamtakt']
            // },
            {
                path: '/company/new/0',
                elements: <CompanyOverviewNew value={value}/>,
                roles: ['superadmin', 'admin',
                    'ticketsystem',
                    'worktime',
                    'teamtakt']
            }
        ]
    }
}

export const CompanyMenuConfig = (value:any) => {
    if(localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined && JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string).isMandant === false) {
        return []
    } else {
        return [

            {
                name: 'Unternehmen',
                route: '/company/overview/1',
                icon: 'apartment',
                roles: ['superadmin', 'admin',
                    'ticketsystem',
                    'worktime',
                    'teamtakt']
            },
            {
                name: 'Neues Unternehmen',
                route: '/company/new/0',
                icon: 'apartment',
                roles: ['superadmin', 'admin',
                    'ticketsystem',
                    'worktime',
                    'teamtakt'],
                permission:['General','Comapny']
            }

        ]
    }
}

export const Software_Support = () => [
    {
        title: 'Support Ticket',
        href: '/support/software/overview/1',
        undertitle: 'Software-Support',
        icon: 'manage_accounts',
        text: 'Software-Support',
        roles: ['superadmin', 'admin',
            'ticketsystem',
            'worktime',
            'teamtakt']
    }
]
